export default __webpack_public_path__ + "static/Loadout_Mannequin-bc2dcc4ed443b11651982e9f19020f66.jpg";